import * as React from 'react';
import { WalletNavigationContext, WalletNavigationContextProps } from '../hoc/WalletNavigationContext';

export const useWalletNavigation = (): WalletNavigationContextProps => {
    const walletNavigation = React.useContext(WalletNavigationContext);
    if (!walletNavigation) {
        throw new Error('Service is not registered yet');
    }

    return walletNavigation;
};
